import React, { Suspense } from 'react';

const LoanComponent = React.lazy(() => import('../Component/LoanComponent/LoanComponent'));

function LendPage(props) {
    return (
        <div>
            <Suspense fallback={<div>Loading...</div>}>
                <LoanComponent record_type='lend' />
            </Suspense>
        </div>
    );
}

export default LendPage;